export default __webpack_public_path__ + "static/media/ParkIcon.14ff5eab.svg";